import JSZip from "jszip";
import { translate } from "./i18n";
import { buildShotsCsv } from "./exportShotsCsv";
import {
  addImagesToZip,
  buildDecoratedShots,
  dateStamp,
} from "./exportShotlistShared";
import { buildShotlistHtmlString } from "./exportShotlistHtml";
import { buildShotlistXlsxBuffer } from "./exportShotlistXlsx";

export async function buildNotionZipPackage({
  shots,
  scenes,
  scriptText,
  lang = "en",
  baseName = "shotlist",
  shotPrefixMode,
  shotFrameFormat,
}) {
  const { y, m, d } = dateStamp();
  const decorated = buildDecoratedShots({
    shots,
    scenes,
    scriptText,
    lang,
    shotPrefixMode,
    shotFrameFormat,
  });

  const zip = new JSZip();
  const imagesFolder = zip.folder("images");
  addImagesToZip(imagesFolder, decorated);

  const html = buildShotlistHtmlString({ decorated, baseName, y, m, d, lang });
  zip.file(`${baseName}_shotlist_${y}-${m}-${d}.html`, html);

  const filename = `${baseName}_notion_${y}-${m}-${d}.zip`;
  const blob = await zip.generateAsync({ type: "blob" });
  return { filename, blob };
}

export async function buildZipPackage({
  shots,
  scenes,
  scriptText,
  lang = "en",
  baseName = "shotlist",
  shotPrefixMode,
  shotFrameFormat,
}) {
  const { y, m, d } = dateStamp();
  const t = (k, vars) => translate(lang, k, vars);

  const zip = new JSZip();

  const decorated = buildDecoratedShots({
    shots,
    scenes,
    scriptText,
    lang,
    shotPrefixMode,
    shotFrameFormat,
  });

  // CSV
  const { filename: csvName, csv } = buildShotsCsv({
    shots,
    scenes,
    scriptText,
    lang,
    shotPrefixMode,
    shotFrameFormat,
  });
  zip.file(csvName, csv);

  // Images
  const imagesFolder = zip.folder("images");
  addImagesToZip(imagesFolder, decorated);

  // XLSX
  const xlsxBuf = await buildShotlistXlsxBuffer(decorated, lang);
  zip.file(`${baseName}_shotlist_${y}-${m}-${d}.xlsx`, xlsxBuf);

  // HTML
  const html = buildShotlistHtmlString({ decorated, baseName, y, m, d, lang });
  zip.file(`${baseName}_shotlist_${y}-${m}-${d}.html`, html);

  // README
  const readme = `${t("export.readme.title")}

${t("export.readme.contentTitle")}
${t("export.readme.content1")}
${t("export.readme.content2")}
${t("export.readme.content3")}

${t("export.readme.usageTitle")}
${t("export.readme.usage1")}
${t("export.readme.usage2")}
`;
  zip.file("README.txt", readme);

  const filename = `${baseName}_package_${y}-${m}-${d}.zip`;
  const blob = await zip.generateAsync({ type: "blob" });
  return { filename, blob };
}
